import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useState } from 'react';

interface RelatoriosAprovacaoFilterProps {
  onFilterChange: (filters: FilterOptions) => void;
}

interface FilterOptions {
  defensorId?: number;
  defensoriaId?: number;
  mes?: string;
  ano?: number;
  tipo?: 'civil' | 'criminal';
  status?: 'enviado' | 'aprovado' | 'reprovado';
  /** Ainda com o diretor: enviado (aguardando análise) ou reprovado pela diretoria (não encaminhados à Corregedoria). */
  statusNaoEnviados?: boolean;
  /** Após aprovação do diretor ou trâmite na Corregedoria: aprovado ou reprovado pela Corregedoria. */
  statusEnviados?: boolean;
}

export default function RelatoriosAprovacaoFilter({
  onFilterChange,
}: RelatoriosAprovacaoFilterProps) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [defensoriaId, setDefensoriaId] = useState<string>('');
  const [mes, setMes] = useState<string>('');
  const [ano, setAno] = useState<number>(currentYear);
  const [tipo, setTipo] = useState<string>('');
  const [status, setStatus] = useState<string>('');

  const handleFilterSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const filters: FilterOptions = {};

    if (defensoriaId) filters.defensoriaId = parseInt(defensoriaId);
    if (mes) filters.mes = mes;
    if (ano) filters.ano = ano;
    if (tipo) filters.tipo = tipo as 'civil' | 'criminal';
    if (status === 'nao_enviados') {
      filters.statusNaoEnviados = true;
    } else if (status === 'enviados') {
      filters.statusEnviados = true;
    } else if (status) {
      filters.status = status as 'enviado' | 'aprovado' | 'reprovado';
    }

    onFilterChange(filters);
  };

  const handleClearFilters = () => {
    setDefensoriaId('');
    setMes('');
    setAno(currentYear);
    setTipo('');
    setStatus('');
    onFilterChange({});
  };

  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const meses = [
    { value: '01', label: 'Janeiro' },
    { value: '02', label: 'Fevereiro' },
    { value: '03', label: 'Março' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Maio' },
    { value: '06', label: 'Junho' },
    { value: '07', label: 'Julho' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' },
  ];

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="bg-light">
        <h5 className="mb-0">Filtros</h5>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleFilterSubmit}>
          {/* Linha 1: legendas */}
          <Row className="mb-1">
            <Col md={2}>
              <Form.Label className="mb-0 fw-bold">Mês</Form.Label>
            </Col>
            <Col md={2}>
              <Form.Label className="mb-0 fw-bold">Ano</Form.Label>
            </Col>
            <Col md={2}>
              <Form.Label className="mb-0 fw-bold">Tipo</Form.Label>
            </Col>
            <Col md={2}>
              <Form.Label className="mb-0 fw-bold">Status</Form.Label>
            </Col>
            <Col md={4} />
          </Row>
          {/* Linha 2: selects e botões Filtrar / Limpar */}
          <Row>
            <Col md={2} className="mb-2">
              <Form.Select
                value={mes}
                onChange={(e) => setMes(e.target.value)}
              >
                <option value="">Todos</option>
                {meses.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={2} className="mb-2">
              <Form.Select
                value={ano}
                onChange={(e) => setAno(parseInt(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={2} className="mb-2">
              <Form.Select
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="civil">Cível</option>
                <option value="criminal">Criminal</option>
              </Form.Select>
            </Col>
            <Col md={2} className="mb-2">
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Todos os status</option>
                <option value="nao_enviados">Não encaminhados à Corregedoria</option>
                <option value="enviados">Aprovados</option>
              </Form.Select>
            </Col>
            <Col md={4} className="d-flex align-items-center gap-2 mb-2">
              <Button type="submit" variant="primary">
                Filtrar
              </Button>
              <Button type="button" variant="outline-secondary" onClick={handleClearFilters}>
                Limpar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
}
